import React from 'react';
import VendorCard from '../../../components/ui/VendorCard';

const VendorGrid = ({ vendors, onVendorClick }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
            {vendors?.map((vendor) => (
                <VendorCard
                    key={vendor?.id}
                    vendor={vendor}
                    onClick={onVendorClick}
                />
            ))}
        </div>
    );
};

export default VendorGrid;